import React, { useEffect } from "react";
import cn from "classnames";
import { useProductContext } from "../../contexts/ProductContext";
import useWindowSize from "../../hooks/useWindowSize";
import FilterList from "./FilterList/FilterList";
import styles from "./Sidebar.module.scss";

const Sidebar: React.FC = () => {
  const {
    openFilter,
    setOpenFilter,
    categories,
    filterValue,
    clearAllFilters,
    selectedCategories,
  } = useProductContext();
  const size = useWindowSize();

  // Check if any filter is active
  const hasActiveFilters =
    selectedCategories.category.length > 0 ||
    selectedCategories.color.length > 0 ||
    selectedCategories.brand.length > 0;

  useEffect(() => {
    if (size.width > 991 && openFilter) {
      setOpenFilter(false);
    }
  }, [size.width, openFilter, setOpenFilter]);

  return (
    <div className={cn(styles.sidebar, openFilter && styles.show)}>
      <div className={styles.sidebar__inner}>
        {hasActiveFilters && (
          <button className={styles.clear_all_btn} onClick={clearAllFilters}>
            Clear All Filters
          </button>
        )}
        {filterValue?.map((item, index) => (
          <div key={index} className={styles.tab_area}>
            <h2 className={styles.sidebar__filter_title}>
              {item.categoryTitle}
            </h2>
            {item.titleArea?.map((filterTitle, i) => (
              <FilterList
                key={i}
                filterTitle={filterTitle.title}
                categories={categories}
                active={filterTitle.active}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
